import { NavigationItem } from '../types';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import NextLink from 'next/link';
import { styles } from '../constants';
import Box from '@mui/material/Box';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import Collapse from '@mui/material/Collapse';

// Mobile navigation list
export default function MobileNavigationList({
  navigation,
  expandedMobileMenu,
  onClose,
  onToggleSubmenu,
}: {
  navigation: NavigationItem[];
  expandedMobileMenu: number | null;
  onClose: () => void;
  onToggleSubmenu: (index: number) => void;
}) {
  const theme = useTheme();

  return (
    <List disablePadding>
      {navigation.map((link, index: number) => {
        if (link._type === 'link' && link.visible && link.href) {
          if (!link.hidden) {
            return (
              <ListItem key={`mobile-link-${index}`} disablePadding>
                <ListItemButton
                  component={NextLink}
                  href={link.href}
                  onClick={onClose}
                  sx={styles.mobileListItem}
                >
                  <ListItemText primary={link.text} />
                </ListItemButton>
              </ListItem>
            );
          }
        } else if (link._type === 'menuHeader') {
          if (!link.hidden) {
            return (
              <Box key={`mobile-menu-${index}`}>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => onToggleSubmenu(index)} sx={styles.mobileListItem}>
                    <ListItemText primary={link.title} />
                    <ExpandMoreRoundedIcon
                      sx={{
                        transform: expandedMobileMenu === index ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: theme.transitions.create('transform'),
                      }}
                    />
                  </ListItemButton>
                </ListItem>
                <Collapse in={expandedMobileMenu === index}>
                  <List component='div' disablePadding>
                    {link.sections.map((section, sectionIndex: number) => {
                      if (!section.hidden) {
                        return (
                          <Box key={sectionIndex}>
                            {/* Section header as a proper list item */}
                            {section.title && (
                              <ListItem disablePadding>
                                <ListItemText
                                  primary={section.title}
                                  sx={{
                                    pl: 2,
                                    py: 1,
                                  }}
                                  slotProps={{
                                    primary: {
                                      variant: 'subtitle2',
                                      sx: {
                                        color: 'var(--mui-palette-success-main)',
                                        fontWeight: 600,
                                        fontSize: '0.875rem',
                                      },
                                    },
                                  }}
                                />
                              </ListItem>
                            )}

                            {/* Section links as nested list items */}
                            {section.links
                              .filter((link) => link.href)
                              .map((link, linkIndex: number) => {
                                const [productName, ...restOfText] = link.text.split(' ');

                                if (!link.hidden) {
                                  return (
                                    <ListItem key={linkIndex} disablePadding>
                                      <ListItemButton
                                        component={NextLink}
                                        href={link.href}
                                        onClick={onClose}
                                        sx={styles.mobileSubItem}
                                      >
                                        {[
                                          'Upper extremities',
                                          'Lower extremities',
                                          'Bovenste ledematen',
                                          'Onderste ledematen',
                                          'Membres supérieurs',
                                          'Obere Extremitäten',
                                          'Untere Extremitäten',
                                          'Extremidades superiores',
                                          'extremidades inferiores',
                                        ].includes(section.title) ? (
                                          <>
                                            <ListItemText
                                              primary={productName}
                                              slotProps={{
                                                primary: {
                                                  variant: 'body2',
                                                  color: 'text.secondary',
                                                  sx: { fontWeight: 'bold' },
                                                },
                                              }}
                                              sx={{
                                                '& .MuiListItemText-primary': {
                                                  width: 'fit-content',
                                                },
                                                flex: '0 0 auto',
                                              }}
                                            />
                                            <ListItemText
                                              primary={restOfText.join(' ')}
                                              slotProps={{
                                                primary: {
                                                  variant: 'body2',
                                                  color: 'text.secondary',
                                                },
                                              }}
                                            />
                                          </>
                                        ) : (
                                          <ListItemText
                                            primary={link.text}
                                            slotProps={{
                                              primary: {
                                                variant: 'body2',
                                                color: 'text.secondary',
                                                sx: { fontWeight: 'bold' },
                                              },
                                            }}
                                          />
                                        )}
                                      </ListItemButton>
                                    </ListItem>
                                  );
                                }
                              })}
                          </Box>
                        );
                      }
                    })}
                  </List>
                </Collapse>
              </Box>
            );
          }
        }
      })}
    </List>
  );
}
